import { render, staticRenderFns } from "./RoomSubOptionsModal.vue?vue&type=template&id=34770dd9&"
import script from "./RoomSubOptionsModal.vue?vue&type=script&lang=js&"
export * from "./RoomSubOptionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports